import React from "react";
import { Spinner } from "react-bootstrap";
import "./PageLoading.css";

export interface PageLoadingProps {
  message?: string;
  minHeight?: string;
}

const PageLoading = ({
  message,
  minHeight = "60vh",
}: PageLoadingProps): React.ReactElement => (
  <div
    className="page-loading"
    style={{ minHeight }}
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Carregando"
  >
    <Spinner animation="border" variant="primary" className="page-loading__spinner" />
    {message ? <span className="page-loading__message">{message}</span> : null}
  </div>
);

export default PageLoading;
